<div [formGroup]="formGroup" *ngIf="nearbySchools" class="nha-sa-nearby-schools-list">
  <h3 class="nha-hide nha-show@md">{{nearbySchools.length}} {{appContent.resourceStrings["nha.sa.nearbyschools"]}}</h3>
  <div class="scroll-list">
    <div *ngFor="let school of nearbySchools let i = index" [ngClass]="{'nha-clear': i % 2 == 0}">
      <app-nearby-schools-list-item
        [hiddenMobile]="i + 1 > schoolsToShowCount"
        [schoolControl]="school"
        [listItemIndex]="i"
        [formGroup]="formGroup"
        [academicYearApplying]="academicYearApplying"
      ></app-nearby-schools-list-item>
    </div>
  </div>
  <div class="nha-row nha-text-center nha-hide@md nha-sa-nearby-schools-more-less">
    <div class="nha-gr-12">
      <button class="nha-btn nha-btn-primary" *ngIf="schoolsToShowCount < nearbySchools.length"
        (click)="showMore()">
        {{appContent.resourceStrings["nha.sa.showmoreschools"]}} <span class="fa fa-angle-double-down"></span>
    </button>
    </div>
    <div class="nha-gr-12">
      <button class="nha-btn nha-btn-primary" *ngIf="schoolsToShowCount >= nearbySchools.length && schoolsToShowCount > 5"
        (click)="showLess()">
        {{appContent.resourceStrings["nha.sa.showlessschools"]}} <span class="fa fa-angle-double-up"></span>
      </button>
    </div>
  </div>
</div>
